import React, { useEffect, useState } from 'react'
import { Breadcrumb, Col, Row } from 'react-bootstrap';
import Card from '../../../UI/Card/Card';
import Graybg from '../../../UI/Graybg';
import SecBTN from '../../../UI/SecBTN';
import Select from '../../../UI/Select/Select';
import classes from './EditQuestion.module.css'
import userService from '../../../app/services/user.service';
import Loader from '../../../UI/loader/loader';
import { Link, useNavigate } from 'react-router-dom';
import { isEmpty, linkReplaceFn } from '../../../utils/custom_funtions';
import Toast from '../../../UI/Toast/Toast';
import { toast } from 'react-toastify';
import Input from '../../../UI/Input/Input';

const EditQuestion = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [showEntries, setShowEntries] = useState(10);
  const [start, setStart] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const initialState = {
    subjectList:[],
    topicList:[],
    subTopicList:[],
    toughnessList:[],
    ansTypeList:[],
    selectedSubject:'',
    selectedTopic:'',
    selectedSubTopic:'',
    selectedQuesType:'',
    selectedToughness:'',
    quesTypeList:[],
    selectedQuesType:'',
    selectedAnsType:'',  
    questionList:[],  
  }
  const [state,setState] = useState(initialState)
  const getSubjectList = () => {
    setIsLoading(true)
    userService.getSubjectList()
    .then(res => {
      setState(prev => {
        return {...prev, subjectList:res.data.data}
      })
      setIsLoading(false)
    })
    .catch(err => {
      console.log(err);
      setIsLoading(false)
    })
  }
  const getTopicList = (subId) => {
    setIsLoading(true)
    userService.getTopicListBySid(subId)
    .then(res => {
      const topiclist = res.data.data.filter(topic => topic.status == 1 && topic.topic_sequence !== null)
      setState(prev => {
        return {...prev, topicList:topiclist,subTopicList:[],selectedTopic:'', selectedSubTopic:''}
      })
      setIsLoading(false)
    })
    .catch(err => {
      console.log(err);
      setState(prev => {
        return {...prev, topicList:[],subTopicList:[],selectedTopic:'',selectedSubTopic:''}
      })
      setIsLoading(false)
    })
  }
  const getSubTopicList = (tid) => {
    setIsLoading(true)
    userService.getSubTopicByTid(tid)
    .then(res => {
      const subtopiclist = res.data.data.filter(subtopic => subtopic.status == 1 && subtopic.sub_topic_sequence !== null)
      console.log(res.data);
      setState(prev => {
        return {...prev, subTopicList:subtopiclist, selectedSubTopic:''}
      })
      setIsLoading(false)
    })
    .catch(err => {
      console.log(err);
      setState(prev => {
        return {...prev, subTopicList:[]}
      })
      setIsLoading(false)
    })
  }
  const getQuesTypeList = () => {
    setIsLoading(true);
    userService
      .getQuesType()
      .then((res) => {
        setState((prev) => {
          return { ...prev, quesTypeList: res.data.data };
        });
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };
  const getAnsTypeList = () => {
    setIsLoading(true);
    userService
      .getAnsType()
      .then((res) => {
        setState((prev) => {
          return { ...prev, ansTypeList: res.data.data };
        });
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };
  const getToughnessList = () => {
    setIsLoading(true)
    userService.getToughness()
    .then(res => {
      setState(prev => {
        return {...prev, toughnessList:res.data.data}
      })
      setIsLoading(false)
    })
    .catch(err => {
      console.log(err);
      setIsLoading(false)
    })
  }
  useEffect(() => {
    getSubjectList();
    getToughnessList();
    getQuesTypeList();
    getAnsTypeList();
  },[])
  const inputHandler = (data) => {
    setState((prev) => {
      return { ...prev, ...data };
    });
  }
  const fetchQuestions = (limit, offset, append = false) => {
    setIsLoading(true)
    const body = {
      sub_id: state.selectedSubject,
      topic_id: state.selectedTopic,
      sub_topic_id: state.selectedSubTopic,
      toughness_id: state.selectedToughness,
      qtype_id: state.selectedQuesType,
      anstype_id: state.selectedAnsType,
      limit: limit,
      start: offset,
    }
    userService.getQuestionList(body)
    .then(res => {
      setIsLoading(false)
      const results = res.data.result || []
      setState(prev => ({
        ...prev,
        questionList: append ? [...prev.questionList, ...results] : results,
      }))
      setStart(offset)
      setHasMore(results.length >= limit)
    })
    .catch(err => {
      setIsLoading(false)
      if (!append) {
        setState(prev => ({ ...prev, questionList: [] }))
        setStart(0)
      }
      setHasMore(false)
      toast.error("No questions found !!")
      console.log(err)
    })
  }

  const searchHandler = () => {
    setStart(0)
    fetchQuestions(showEntries, 0, false)
  }
  const navigate = useNavigate()
  const getOverviewData = (searchQid) => {
    userService
      .getOverviewData(searchQid)
      .then((res) => {
          navigate(`/editQuestion/edit/${searchQid}`)
      })
      .catch((err) => {
        console.log(err);
        toast.error(`Data not found for this QID`)
      });
  };
  const qidSubmit = e => {
    e.preventDefault();
    console.log(e.target[0].value)
    getOverviewData(e.target[0].value)
  }
  return (
    <>
    <Toast/>
      {isLoading && <Loader />}
      <div className="section">
        <div className="d-flex justify-content-between align-items-center h-100">
          <div>
            <h4>Edit Question</h4>
            <Breadcrumb>
              <Breadcrumb.Item active>Question</Breadcrumb.Item>
              <Breadcrumb.Item active>Edit Question</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Link to="addQuestion">
            <SecBTN className={`sec-btn ${classes.btn}`}>
              Add New Question
            </SecBTN>
          </Link>
        </div>
        <form className="d-flex justify-content-between align-items-center gap-3 mb-4 px-3" onSubmit={qidSubmit} >
            <Input
              style={{ backgroud: "#fff" }}
              type="number"
              placeholder="Search QID"
              name="qid"
            />
            <SecBTN type='submit' className="sec-btn1" style={{ padding: "0.25rem 1rem" }}>
              Search
            </SecBTN>
          </form>
        <Graybg>
          <Card className={classes.filter}>
            <Row>
              <Col lg={6} sm={12} className="my-1">
                <Select
                  value={state.selectedSubject}
                  onChange={(e) => {
                    inputHandler({selectedSubject: e.target.value})
                    getTopicList(e.target.value);
                  }}
                >
                  <option value="" >
                    Select Subject
                  </option>
                  {state.subjectList.map((subject) => {
                    return (
                      <option key={subject.sub_id} value={subject.sub_id}>
                        {subject.sub_name}
                      </option>
                    );
                  })}
                </Select>
              </Col>
              <Col lg={6} sm={12} className="my-1">
                <Select
                  value={state.selectedTopic}
                  onChange={(e) => {
                    inputHandler({selectedTopic: e.target.value})
                    getSubTopicList(e.target.value);
                  }}
                >
                  <option value="" >
                    Select Topic
                  </option>
                  {state.topicList.map((topic) => {
                    return (
                      <option key={topic.topic_id} value={topic.topic_id}>
                        {topic.topic_name}
                      </option>
                    );
                  })}
                </Select>
              </Col>
              <Col lg={6} sm={12} className="my-1">
                <Select
                  value={state.selectedSubTopic}
                  onChange={(e) => {
                    inputHandler({selectedSubTopic: e.target.value})
                  }}
                >
                  <option value="" >
                    Select Sub-Topic
                  </option>
                  {state.subTopicList.map((subtopic) => {
                    return (
                      <option
                        key={subtopic.sub_topic_id}
                        value={subtopic.sub_topic_id}
                      >
                        {subtopic.Sub_topic_name}
                      </option>
                    );
                  })}
                </Select>
              </Col>
              <Col lg={6} sm={12} className="my-1">
                <Select
                  value={state.selectedQuesType}
                  onChange={(e) => {
                    inputHandler({selectedQuesType: e.target.value})
                  }}
                >
                  <option value="">
                    Select Question type
                  </option>
                  {state.quesTypeList.map((quesType) => {
                    return (
                      <option value={quesType.type_id}>{quesType.type}</option>
                    );
                  })}
                </Select>
              </Col>
              <Col lg={6} sm={12} className="my-1">
                <Select
                  value={state.selectedToughness}
                  onChange={(e) => {
                    inputHandler({selectedToughness: e.target.value})
                  }}
                >
                  <option value="" >
                    Select Toughness
                  </option>
                  {state.toughnessList.map(({ toughness_id, toughness }) => {
                    return (
                      <option key={toughness_id} value={toughness_id}>
                        {toughness}
                      </option>
                    );
                  })}
                </Select>
              </Col>
              <Col lg={6} sm={12} className="my-1">
              <Select value={state.selectedAnsType}
              onChange={(e) => {
                inputHandler({selectedAnsType: e.target.value})
                }}
              >
                <option value=''>
                 Select Answer type
                </option>
                {state.ansTypeList.map((ansType) => {
                  return <option value={ansType.answer_id}>{ansType.answer_type}</option>
                })}
              </Select>
              </Col>
            </Row>
            <div className="mt-3 text-center">
              <SecBTN className="sec-btn1" onClick={searchHandler}>Search</SecBTN>
            </div>
          </Card>
          {/* <DataTable /> */}
          {!isEmpty(state.questionList) ? (
            <>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <div>
                Show{" "}
                <select
                  value={showEntries}
                  onChange={(e) => {
                    const value = +e.target.value
                    setShowEntries(value)
                    setStart(0)
                    if (!isEmpty(state.questionList)) {
                      fetchQuestions(value, 0, false)
                    }
                  }}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                  <option value={1000}>ALL</option>
                </select>{" "}
                entries
              </div>
              <p className="mb-0 small">
                {showEntries === 1000 ? (
                  <>Showing <b>{state.questionList.length}</b> entries</>
                ) : (
                  <>Showing <b>{start + 1}</b> to <b>{start + state.questionList.length}</b> entries</>
                )}
              </p>
            </div>
            <div className="table-responsive mb-3">
              <table className="table table-bordered mt-2 mb-0">
                <thead className={classes.tblheader}>
                  <tr>
                    <th>QID</th>
                    <th>Question</th>
                    <th>Subject</th>
                    <th>Topic</th>  
                    <th>Sub-Topic</th>
                    <th>Type</th>
                    <th>Toughness</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {state.questionList.map((qList) => {
                      return (
                        <tr key={qList.qid}>
                          <th scope="row">{qList.qid}</th>
                          <td>
                            <p
                              dangerouslySetInnerHTML={{
                                __html: linkReplaceFn(qList.q_text_string),
                              }}
                            />
                          </td>
                          <td>{qList['sub_name']}</td>
                          <td>{qList['topic_name']}</td>
                          <td>{qList['sub_topic_name']}</td>
                          <td>{qList['qus_type']}</td>
                          <td>{qList['toughness']}</td>
                          <td><Link to={`edit/${qList.qid}`}><SecBTN className='sec-btn1'>Edit</SecBTN></Link></td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
            <div className='d-flex justify-content-between'>
            {showEntries === 1000 ? (
              hasMore && (
                <SecBTN
                  className="sec-btn1 ms-auto"
                  onClick={() => fetchQuestions(showEntries, state.questionList.length, true)}
                >
                  Load More
                </SecBTN>
              )
            ) : (
              <>
                <SecBTN
                  className="sec-btn1"
                  disabled={start === 0}
                  onClick={() => fetchQuestions(showEntries, Math.max(0, start - showEntries), false)}
                >
                  Prev
                </SecBTN>
                <SecBTN
                  className="sec-btn1"
                  disabled={!hasMore}
                  onClick={() => fetchQuestions(showEntries, start + showEntries, false)}
                >
                  Next
                </SecBTN>
              </>
            )}
            </div>
            </>
          ) 
          : ""
          }
        </Graybg>
      </div>
    </>
  );
}

export default EditQuestion
